// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".description_div[data-v-7be0959b]{position:absolute;top:12%;left:42%}.short-description[data-v-7be0959b]{max-width:450px;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:5;overflow:hidden}@media (max-width:1264px){.description_div[data-v-7be0959b]{position:absolute;top:5%;left:42%}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
